import React from "react";
import contentfulPluginsFactory, { fetchProps } from "@insightfulscience/contentful/Apps/Plugins";
import PageMeta from "@insightfulscience/smart-react/PageMeta";
import { useLocale } from "@insightfulscience/smart-react/i18";
import SectionTryForFree from "../../SectionTryForFree";
import SiteLayout from "../../SiteLayout";
import Page from "../../contentful/Apps/Plugins/Page";
import { contentfulProps } from "../../config";
import resources from "../../../locales";

const pluginsLayout = ({ children }) => {
	const [t] = useLocale("plugins");
	return (
		<SiteLayout>
			<PageMeta>
				<PageMeta.Twitter image={t("META_TWITTER_IMAGE")} isImageBaseUrl />
			</PageMeta>
			{children}
			<SectionTryForFree />
		</SiteLayout>
	);
};

const ContentfulPluginsApp = contentfulPluginsFactory({
	Layout: pluginsLayout,
	Page,
	contentfulProps,
	pageProps: {
		brandCode: "gn",
		siteDomain: "https://www.geneious.com",
		resources,
	},
	mode: "isr",
});

export const getStaticPaths = async () => ({
	paths: [],
	fallback: "blocking",
});

export const getStaticProps = async ({ params: { slug } }) => {
	const props = await fetchProps(contentfulProps, slug, false);

	return props?.post
		? {
				props,
				revalidate: false,
		  }
		: { notFound: true };
};

export default ContentfulPluginsApp;
